import { Link } from '@schuettflix/react-components';
import { PlusIcon } from '@schuettflix/icons-react';
import { useTranslation } from 'react-i18next';
import { useMemo, useState } from 'react';
import { ContactPanel } from '@/modules/location/components/contactperson/ContactPanel.tsx';
import { ContactCard } from '@/modules/location/components/contactperson/ContactCard.tsx';
import { ContactPerson } from '@/modules/location/domain/ContactPersonSchema.ts';

interface ContactPersonViewProps {
    value: ContactPerson | null;
    onChange: (value: ContactPerson | null) => void;
    disabled?: boolean;
}

export const ContactPersonSection = (props: ContactPersonViewProps) => {
    const { t } = useTranslation();
    const [showContactPersonPanel, setShowContactPersonPanel] = useState<boolean>(false);
    const activateContactPersonPanel = useMemo(
        () => (props.disabled ? undefined : () => setShowContactPersonPanel(true)),
        [props.disabled]
    );

    return (
        <div className="space-y-2">
            {props.value ? (
                <ContactCard
                    value={props.value}
                    onDelete={() => {
                        props.onChange(null);
                    }}
                    onClick={activateContactPersonPanel}
                />
            ) : (
                <Link
                    tabIndex={0}
                    prefix={<PlusIcon size="xs" />}
                    className="font-copy-md-strong pt-1"
                    label={t('contactPerson.link')}
                    onClick={activateContactPersonPanel}
                    onKeyDown={e => {
                        if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault();
                            props.onChange(null);
                        }
                    }}
                    disabled={props.disabled}
                />
            )}

            {showContactPersonPanel && (
                <ContactPanel
                    value={props.value}
                    onClose={() => {
                        setShowContactPersonPanel(false);
                    }}
                    onSubmit={(value: ContactPerson | null) => {
                        props.onChange(value);
                        setShowContactPersonPanel(false);
                    }}
                ></ContactPanel>
            )}
        </div>
    );
};
